import { ROUTES } from './routes';

// Route → i18n key for the browser tab title. Keys are reused from the sidebar
// (`navigation.*`) wherever a page has a menu entry, so a title never drifts
// from its menu label.
//
// Resolution is longest-prefix, so one section entry ('/app/clients') also
// covers that section's detail and create/edit pages.
const PAGE_TITLE_KEYS: Record<string, string> = {
  [ROUTES.DASHBOARD]: 'common:navigation.dashboard',
  [ROUTES.CLIENTS]: 'common:navigation.clients',
  [ROUTES.CONTRACTS]: 'common:navigation.contracts',
  [ROUTES.MATTERS]: 'common:navigation.matters',
  '/app/new-tasks': 'common:navigation.newTasks',
  '/app/my-tasks': 'common:navigation.myTasks',
  '/app/lead-review': 'common:navigation.leadReview',
  '/app/partner-review': 'common:navigation.partnerReview',
  '/app/approve-to-billing': 'common:navigation.approveToBilling',
  [ROUTES.SETTINGS]: 'common:navigation.settings',
  '/app/settings/activity-types': 'common:navigation.activityTypes',
  '/app/settings/task-types': 'common:navigation.taskTypes',
  '/app/settings/payment-methods': 'common:navigation.paymentMethods',
  '/app/settings/expense-categories': 'common:navigation.expenseCategories',
  '/app/settings/matter-practice-areas': 'common:navigation.matterPracticeAreas',
  '/app/settings/contract-practice-areas': 'common:navigation.contractPracticeAreas',
  '/app/settings/contract-periods': 'common:navigation.contractPeriods',
  '/app/settings/qa-criteria': 'common:navigation.qaCriteria',
  [ROUTES.CALENDAR]: 'common:navigation.calendar',
  '/app/leo': 'common:navigation.leo',
  '/app/expenses': 'common:navigation.expenses',
  '/app/bills': 'common:navigation.bills',
  '/app/payments': 'common:navigation.payments',
  '/app/hourly-packages': 'common:hourlyPackages',
  '/app/success-packages': 'common:successPackages',
  '/app/kpi': 'common:navigation.kpi',
  '/app/users': 'common:navigation.users',
  '/app/roles': 'common:roles',
  '/app/attendances': 'common:attendances',
  '/app/devices': 'common:devices',
  '/app/reviews': 'common:navigation.reviews',
  '/app/complaints': 'common:navigation.complaints',
  [ROUTES.REPORTS]: 'common:navigation.reports',
  '/app/forbidden': 'common:forbidden.title',
  '/app/not-found': 'common:notFound',
};

// Longest first, so '/app/settings/task-types' wins over '/app/settings'.
const PAGE_TITLE_PREFIXES = Object.entries(PAGE_TITLE_KEYS).sort(
  ([a], [b]) => b.length - a.length,
);

/**
 * i18n key for the given path's tab title, or `undefined` when the path has no
 * title of its own (the caller then falls back to the app name).
 */
export function resolvePageTitleKey(pathname: string): string | undefined {
  // Login is the only path outside /app, and '/' prefixes everything else.
  if (pathname === ROUTES.LOGIN) return 'auth:login.title';

  return PAGE_TITLE_PREFIXES.find(
    ([prefix]) => pathname === prefix || pathname?.startsWith(`${prefix}/`),
  )?.[1];
}
